export const MAP_TILE_LAYER = 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png';

export const MAP_ATTRIBUTION = `
	&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors
`;

export const MAP_MAX_ZOOM = 18;
